<div class="modal-fade">
      <h1>Your trial is over!</h1>
      <p>
        We hope you've had a great experience with Get More Reviews! Please activate your account by filling in your billing information below.
        If you have additionals questions before activating, click <a href="https://www.getmorereviews.com/" target="_blank">here</a> to start a chat with us
      </p>
      <iframe id="iframe" class="frame" [src]="sanitizedTrailOverForm" frameborder="0"></iframe>
</div>